export const APPS = [
  {
    title: "Sod Farms",
    desc: "Uniform, repeatable cuts across thousands of acres of production turf.",
    img: "https://static.prod-images.emergentagent.com/jobs/e9dc7377-0248-4f5e-98bd-812b53b60fbf/images/bac709122a547f8cc7313740fea9bffcecc213bb581165c282353c898ade829b.png",
  },
  {
    title: "Polo Fields",
    desc: "Championship polo grounds kept level, true, and immaculately striped between chukkas.",
    img: "https://images.unsplash.com/photo-1782295848330-1485b8bfff31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwb2xvJTIwbWF0Y2glMjBob3JzZXMlMjBwbGF5ZXJzJTIwZ3JlZW4lMjBncmFzc3xlbnwwfHx8fDE3ODI4MzI2MjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Airports",
    desc: "Vast airfield acreage maintained safely within strict perimeters.",
    img: "https://images.unsplash.com/photo-1683971113886-ca5883e598b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwcnVud2F5JTIwYWVyaWFsJTIwZ3JlZW58ZW58MHx8fHwxNzgyNzQ5ODcyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Select Outdoor Sports Complexes",
    desc: "Striped, championship-ready pitches with zero idle downtime.",
    img: "https://images.unsplash.com/photo-1517747614396-d21a78b850e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzdGFkaXVtJTIwZm9vdGJhbGwlMjBmaWVsZHxlbnwwfHx8fDE3ODI3NDk3Nzh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Private Acreage",
    desc: "Expansive private grounds and large lawns kept immaculate with minimal hands-on labor.",
    img: "https://images.unsplash.com/photo-1630284791466-70e3c81440ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXJnZSUyMHByaXZhdGUlMjBjb3VudHJ5JTIwZXN0YXRlJTIwZ3JlZW4lMjBsYXduJTIwYWVyaWFsfGVufDB8fHx8MTc4MjgyNTI0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Private Airfields",
    desc: "Grass runways and surrounding acreage maintained safely within tight operational perimeters.",
    img: "https://images.unsplash.com/photo-1671116609053-d4eb1dedba85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxzbWFsbCUyMHByaXZhdGUlMjBhaXJmaWVsZCUyMGdyYXNzJTIwcnVud2F5JTIwYWVyaWFsfGVufDB8fHx8MTc4MjgyNTI2N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const STATS = [
  { display: "12-14", suffix: " AC", label: "Acres per hour" },
  { display: "15.5", suffix: " FT", label: "Cutting width" },
  { value: 50, suffix: " HP", label: "Engine power" },
  { display: "<1", suffix: " IN", label: "RTK-GPS accuracy" },
];

export const SPECS = [
  { label: "Models", value: "2WD & 4WD versions" },
  { label: "Engine", value: "50 HP Tier 5 Kubota (no DEF)" },
  { label: "Fuel", value: "Diesel" },
  { label: "Cutting width", value: "15.5 ft per pass" },
  { label: "Cutting height", value: '3/4" – 3"' },
  { label: "Mowing capacity", value: "Up to 14.1 acres / hr" },
  { label: "GPS accuracy", value: "RTK < 1 inch" },
  { label: "Operational weight", value: "7,500 lbs" },
  { label: "Transport size", value: "8' W × 9' H × 17' L" },
  { label: "Safety", value: "Two 360° LiDAR" },
];

export const FEATURES = [
  {
    key: "autonomous",
    tag: "01 / Autonomous",
    title: "Fully Autonomous Operation",
    desc: "Define your boundaries once. The 50 HP Navigator mows up to 14 acres an hour with a 15.5 ft cutting width, unattended \u2014 freeing your crew for skilled, high-value work.",
    video: "https://customer-assets.emergentagent.com/job_proturf-flagship/artifacts/2i8txu45_CLIP_2_NAVIGATOR.mp4",
    img: "https://customer-assets.emergentagent.com/job_proturf-flagship/artifacts/cai2ypnk_NAVIGATOR_1_Horizontal_1_11zon.png",
  },
  {
    key: "rtk",
    tag: "02 / Precision",
    title: "RTK-GPS Precision",
    desc: "Centimeter-accurate real-time kinematic positioning delivers flawless, repeatable striping and zero-overlap coverage \u2014 even on complex, contoured terrain.",
    img: "https://customer-assets.emergentagent.com/job_proturf-flagship/artifacts/ortsz5bh_20250307_123723.jpg",
    hoverVideo: "/api/media/rtk.mp4",
  },
  {
    key: "lidar",
    tag: "03 / Safety",
    title: "Lidar Safety System",
    desc: "A 360\u00b0 LiDAR system continuously scans in every direction, detecting people, pets, and equipment and bringing the machine to a controlled stop before any contact is possible.",
    img: "https://customer-assets.emergentagent.com/job_proturf-flagship/artifacts/xt1yglqj_openart-3efe0221-1a82-4971-bd07-7574efae6443%20%281%29.png",
    lidarAnim: true,
  },
  {
    key: "path",
    tag: "04 / Intelligence",
    title: "Intelligent Path Planning",
    desc: "On-board AI computes the most efficient route for any property shape, optimizing fuel, cut quality, and total coverage time automatically.",
    img: "https://customer-assets.emergentagent.com/job_proturf-flagship/artifacts/vex6y5ft_20250307_123652.jpg",
    hoverVideo: "/api/media/path.mp4",
  },
];

export const COMPARISON = [
  { metric: "Labor per machine", traditional: "40+ hrs / operator", navigator: "Near zero" },
  { metric: "Operating model", traditional: "Manual ride-on", navigator: "Autonomous, app-controlled" },
  { metric: "Cut consistency", traditional: "Operator-dependent", navigator: "\u00b12 cm every pass" },
  { metric: "Coverage rate", traditional: "Varies by operator", navigator: "Up to 14 acres / hr" },
  { metric: "Crew required", traditional: "1 operator each", navigator: "Monitor fleet remotely" },
  { metric: "Safety", traditional: "Operator fatigue risk", navigator: "360\u00b0 sensor auto-stop" },
];

export const APP_FEATURES = [
  "Draw field boundaries right on the satellite map",
  "Dispatch jobs with custom stripe angle & passes",
  "Live machine status, location & active stats",
  "Full job history and past-job reports",
];

export const BENEFITS = [
  { title: "Lower Total Cost", desc: "Cut labor, fuel, and overtime hours \u2014 redeploy your crew to skilled, higher-value work." },
  { title: "Predictive Maintenance", desc: "Self-diagnostics flag blade wear and service needs before they cause downtime." },
  { title: "50 HP Of Muscle", desc: "A rugged 50 HP engine drives a 15.5 ft cutting width through tall, heavy, and demanding turf without slowing down." },
  { title: "2WD & 4WD All-Terrain", desc: "Choose 2WD or 4WD drivetrains \u2014 built to handle slopes, rough ground, and every terrain you operate on." },
];
